import React, { useEffect } from 'react';
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import Header from '@/components/layout/Header';
import Footer from '@/components/layout/Footer';
import AccessibilityWidget from '@/components/AccessibilityWidget';
import HomePage from '@/pages/HomePage';
import ServicesPage from '@/pages/ServicesPage';
import HeatingServicesPage from '@/pages/services/HeatingServicesPage';
import CoolingServicesPage from '@/pages/services/CoolingServicesPage';
import InstallationPage from '@/pages/services/InstallationPage';
import AirQualityPage from '@/pages/services/AirQualityPage';
import SpecialsPage from '@/pages/SpecialsPage';
import SpecialDetailPage from '@/pages/SpecialDetailPage';
import ComfortLoyaltyPage from '@/pages/ComfortLoyaltyPage';
import SignUpPage from '@/pages/SignUpPage';
import BlogPage from '@/pages/BlogPage';
import BlogArticlePage from '@/pages/BlogArticlePage';
import ContactPage from '@/pages/ContactPage';
import ServiceAreasPage from '@/pages/ServiceAreasPage';
import CityPage from '@/pages/CityPage';
import FAQPage from '@/pages/FAQPage';
import PrivacyPolicyPage from '@/pages/PrivacyPolicyPage';
import TermsConditionsPage from '@/pages/TermsConditionsPage';
import WebsiteAccessibilityPage from '@/pages/WebsiteAccessibilityPage';
import ThankYouPage from '@/pages/ThankYouPage';
import { SiteTracker } from '@/components/SiteTracker';

const AdminApp = React.lazy(() => import('@/admin/AdminApp'));

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
}

// Old /admin links -> /dashboard
function AdminRedirect() {
  const { pathname, search } = useLocation();
  return <Navigate to={`${pathname.replace(/^\/admin/i, '/dashboard')}${search}`} replace />;
}

function SiteShell() {
  return (
    <>
      <SiteTracker />
      <Header />
      <div className="flex-1">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/services/heating" element={<HeatingServicesPage />} />
          <Route path="/services/heating/:subservice" element={<HeatingServicesPage />} />
          <Route path="/services/cooling" element={<CoolingServicesPage />} />
          <Route path="/services/cooling/:subservice" element={<CoolingServicesPage />} />
          <Route path="/services/installation" element={<InstallationPage />} />
          <Route path="/services/installation/:subservice" element={<InstallationPage />} />
          <Route path="/services/air-quality" element={<AirQualityPage />} />
          <Route path="/services/air-quality/:subservice" element={<AirQualityPage />} />
          <Route path="/specials" element={<SpecialsPage />} />
          <Route path="/specials/:slug" element={<SpecialDetailPage />} />
          <Route path="/comfort-loyalty" element={<ComfortLoyaltyPage />} />
          <Route path="/comfort-loyalty/sign-up" element={<SignUpPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogArticlePage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/service-areas" element={<ServiceAreasPage />} />
          <Route path="/service-areas/:city" element={<CityPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-conditions" element={<TermsConditionsPage />} />
          <Route path="/website-accessibility" element={<WebsiteAccessibilityPage />} />
          <Route path="/thank-you" element={<ThankYouPage />} />
        </Routes>
      </div>
      <Footer />
      <AccessibilityWidget />
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <div className="App min-h-screen flex flex-col">
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/dashboard/*" element={<React.Suspense fallback={null}><AdminApp /></React.Suspense>} />
            <Route path="/admin/*" element={<AdminRedirect />} />
            <Route path="*" element={<SiteShell />} />
          </Routes>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
